import { Fragment, useContext } from "react";
import "./MenuIcon.scss";
import { menuContext } from "../../context/menucontext";

const MenuIcon = ({theme}) => {

  const {menuStatus, setMenuStatus} = useContext(menuContext);

  const menuToggler = (e) => {
    e.stopPropagation();
    setMenuStatus(!menuStatus);
  
  };

  return (
    <Fragment>
      <div
        className={`hemberger_menu ${menuStatus ? "open" : ""}`}
        onClick={menuToggler}
      >
        <div className={`bar ${theme}`}></div>
        <div className={`bar ${theme}`}></div>
        <div className={`bar ${theme}`}></div>
      </div>
    </Fragment>
  );
};

export default MenuIcon;